import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import EditLocationComp from "./Component/EditLocationComp"


const EditLocation =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EditLocationComp />
        </div>
        <Footer />
        </>
    )
}

export default EditLocation